import { STORAGE_KEY } from '../constants/generic';
import { getAppObj } from './utils';

export function parseAuthTokensFromApi(headers) {
  let { 'x-auth-token': token, 'x-refresh-token': refreshToken } = headers || {};

  if (token === 'null') token = undefined;
  if (refreshToken === 'null') refreshToken = undefined;
  return { token, refreshToken };
}

export function clearAuthTokens() {
  console.log('[KC-DEBUG] tokens.js/clearAuthTokens: dropping the legacy (non-SSO) tokens from memory + localStorage', { hadToken: Boolean(getAppObj()[STORAGE_KEY.AUTH_TOKEN]), hadRefreshToken: Boolean(getAppObj()[STORAGE_KEY.AUTH_REFRESH_TOKEN]) }); // eslint-disable-line no-console
  delete getAppObj()[STORAGE_KEY.AUTH_TOKEN];
  localStorage.removeItem(STORAGE_KEY.AUTH_TOKEN);
  delete getAppObj()[STORAGE_KEY.AUTH_REFRESH_TOKEN];
  localStorage.removeItem(STORAGE_KEY.AUTH_REFRESH_TOKEN);
}

export function clearSsoTokens() {
  console.log('[KC-DEBUG] tokens.js/clearSsoTokens: dropping the SSO tokens from memory + localStorage (after this any /me call goes out UNAUTHENTICATED)', { hadToken: Boolean(getAppObj()[STORAGE_KEY.SSO_TOKEN]), tokenLength: getAppObj()[STORAGE_KEY.SSO_TOKEN]?.length, hadRefreshToken: Boolean(getAppObj()[STORAGE_KEY.SSO_REFRESH_TOKEN]) }); // eslint-disable-line no-console
  delete getAppObj()[STORAGE_KEY.SSO_TOKEN];
  localStorage.removeItem(STORAGE_KEY.SSO_TOKEN);
  delete getAppObj()[STORAGE_KEY.SSO_REFRESH_TOKEN];
  localStorage.removeItem(STORAGE_KEY.SSO_REFRESH_TOKEN);
}

export function saveSsoTokens({ token, refreshToken } = getAppObj().keycloak || {}) {
  console.log('[KC-DEBUG] tokens.js/saveSsoTokens: storing SSO tokens in memory (no token => later /me goes out UNAUTHENTICATED)', { hasToken: Boolean(token), tokenLength: token?.length, hasRefreshToken: Boolean(refreshToken) }); // eslint-disable-line no-console
  console.log('[KC-DEBUG] tokens.js/saveSsoTokens: source of the tokens (defaults to window.APP.keycloak; a KC client that never authenticated hands over undefined)', { calledWithExplicitArg: undefined !== token || undefined !== refreshToken, kcClientPresent: Boolean(getAppObj().keycloak), kcAuthenticated: getAppObj().keycloak?.authenticated, kcDidInitialize: getAppObj().keycloak?.didInitialize, refreshTokenLength: refreshToken?.length, atIso: new Date().toISOString() }); // eslint-disable-line no-console
  // Tokens are kept in memory only (never persisted to web storage) to limit XSS exposure.
  if (token) getAppObj()[STORAGE_KEY.SSO_TOKEN] = token;
  if (refreshToken) getAppObj()[STORAGE_KEY.SSO_REFRESH_TOKEN] = refreshToken;
  clearAuthTokens();
}

export function saveAuthTokens({ token, refreshToken }) {
  console.log('[KC-DEBUG] tokens.js/saveAuthTokens: storing legacy (non-SSO) tokens in memory - this also WIPES the SSO tokens', { hasToken: Boolean(token), tokenLength: token?.length, hasRefreshToken: Boolean(refreshToken) }); // eslint-disable-line no-console
  // Tokens are kept in memory only (never persisted to web storage) to limit XSS exposure.
  if (token) getAppObj()[STORAGE_KEY.AUTH_TOKEN] = token;
  if (refreshToken) getAppObj()[STORAGE_KEY.AUTH_REFRESH_TOKEN] = refreshToken;
  clearSsoTokens();
}

// Tokens are no longer persisted to web storage. These functions remain to purge any
// tokens left in localStorage by previous app versions (security hardening / migration).
export function restoreAuthTokens() {
  console.log('[KC-DEBUG] tokens.js/restoreAuthTokens: purging any legacy tokens left in localStorage by older app versions (despite the name it RESTORES NOTHING)', { hadLegacyToken: Boolean(localStorage.getItem(STORAGE_KEY.AUTH_TOKEN)), hadLegacyRefreshToken: Boolean(localStorage.getItem(STORAGE_KEY.AUTH_REFRESH_TOKEN)) }); // eslint-disable-line no-console
  localStorage.removeItem(STORAGE_KEY.AUTH_TOKEN);
  localStorage.removeItem(STORAGE_KEY.AUTH_REFRESH_TOKEN);
}

export function restoreSsoTokens() {
  console.log('[KC-DEBUG] tokens.js/restoreSsoTokens: purging any SSO tokens left in localStorage by older app versions (despite the name it RESTORES NOTHING - an SSO session can ONLY come back through kc.init() check-sso)', { hadSsoToken: Boolean(localStorage.getItem(STORAGE_KEY.SSO_TOKEN)), hadSsoRefreshToken: Boolean(localStorage.getItem(STORAGE_KEY.SSO_REFRESH_TOKEN)) }); // eslint-disable-line no-console
  localStorage.removeItem(STORAGE_KEY.SSO_TOKEN);
  localStorage.removeItem(STORAGE_KEY.SSO_REFRESH_TOKEN);
}

export function getAppAuthTokens() {
  return {
    token: getAppObj()[STORAGE_KEY.AUTH_TOKEN],
    refreshToken: getAppObj()[STORAGE_KEY.AUTH_REFRESH_TOKEN]
  };
}

export function getAppSsoTokens() {
  return {
    token: getAppObj()[STORAGE_KEY.SSO_TOKEN],
    refreshToken: getAppObj()[STORAGE_KEY.SSO_REFRESH_TOKEN]
  };
}

export function noTokensFound() {
  const tokens = getAppAuthTokens();
  const ssoTokens = getAppSsoTokens();

  console.log('[KC-DEBUG] tokens.js/noTokensFound: token presence snapshot (drives the session-expired redirect)', { hasAuthToken: Boolean(tokens.token), hasAuthRefreshToken: Boolean(tokens.refreshToken), hasSsoToken: Boolean(ssoTokens.token), ssoTokenLength: ssoTokens.token?.length, hasSsoRefreshToken: Boolean(ssoTokens.refreshToken) }); // eslint-disable-line no-console
  return !(
    tokens.token ||
    tokens.refreshToken ||
    ssoTokens.token ||
    ssoTokens.refreshToken
  );
}
